import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

const ViewInventory = ({ onCloseModal, materials = [] }) => {
	return (
		<ModalContainer className="inventory-list-mdoal">
			<div className="popup-wrapper">
				<div className="common-popup">
					<ModalHeader title="Inventory List" onClose={onCloseModal} />
					<div className="common-popup-body scroll-y-label">
						<div className="material-requirement-table">
							<table className="table height-sm hover with-border">
								<thead>
									<tr>
										<th>Reference Number</th>
										<th>Fabric Type</th>
										<th>Name</th>
										<th>Balance</th>
										<th>GSM</th>
									</tr>
								</thead>
								<tbody>
									{materials?.map((item) => (
										<tr>
											<td>{item.referenceNumber}</td>
											<td>{item.fabricConstructionGroupResponse?.fabricType}</td>
											<td>{item.fabricConstructionGroupResponse?.name}</td>
											<td>{item.balance}</td>
											<td>{item.gsm}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ViewInventory;
